export function linkedhashmap(data) {
    const originalChildLookup = new Map();
    data.forEach((item) => {
        if (item.parentcategoryid !== -1) {
            if (!originalChildLookup.has(item.parentcategoryid)) {
                originalChildLookup.set(item.parentcategoryid, []);
            }
            originalChildLookup.get(item.parentcategoryid).push(item);
        }
    });
    const activeNodes = data.filter(
        (item) => item.active == 1 && item.recid >= 0
    );
    console.log(activeNodes,"activeNodes")
    const nodeMap = new Map();
    activeNodes.forEach((item) => {
        nodeMap.set(item.recid, {
            name: item.name,
            recid: item.recid,
            color: item.color,
            parentcategoryid: Number(item.parentcategoryid),
            children: [],
        });
    });
    nodeMap.forEach((node) => {
        if (
            node.parentcategoryid !== -1 &&
            nodeMap.has(node.parentcategoryid)
        ) {
            const parent = nodeMap.get(node.parentcategoryid);
            parent.children.push(node);
        }
    });
    let roots = Array.from(nodeMap.values()).filter((node) => {
        return (
            node.parentcategoryid == -1 ||
            !nodeMap.has(node.parentcategoryid)
        );
    });

    function pruneInactiveParents(node) {
        const originallyHadChildren = originalChildLookup.has(node.recid);
        if (originallyHadChildren && node.children.length === 0) {
            return false;
        }
        node.children = node.children.filter(pruneInactiveParents);
        return true;
    }

    roots = roots.filter(pruneInactiveParents);

    return roots;
}


export function storeLeafCategories(
    node,
    finalActiveCategoryData,
    parentChain = []
) {
    const currentChain = [...parentChain, node.name];

    if (!node.children || node.children.length === 0) {
        const fullParentPath = parentChain.join(" > ") || "";

        finalActiveCategoryData[
            node.recid
        ] = `${node.name}$${node.color}$${fullParentPath}`;
    } else {
        node.children.forEach((child) =>
            storeLeafCategories(
                child,
                finalActiveCategoryData,
                currentChain
            )
        );
    }
}


export function linkedhashmapdata(data) {
    const map = new Map();

    data.forEach((item) => {

        map.set(item.recid, {
            name: item.name,
            recid: item.recid,
            color: item.color,
            parentcategoryid: Number(item.parentcategoryid),
            children: [],
        });

    });
// console.log(map,"map")
    const parentIds = new Set();
    map.forEach((item) => {
        if (item.parentcategoryid !== -1) {
            parentIds.add(item.parentcategoryid);
        }
    });

    const leaves = Array.from(map.values()).filter(
        (item) => !parentIds.has(item.recid)
    );
    const results = [];

    for (const leaf of leaves) {
        let current = { ...leaf, children: [] };
        let parent = map.get(current.parentcategoryid);

        const visited = new Set([current.recid]);

        while (parent && !visited.has(parent.recid)) {
            const parentCopy = {
                name: parent.name,
                recid: parent.recid,
                color: parent.color,
                children: [current],
                parentcategoryid: parent.parentcategoryid,
            };

            current = parentCopy;
            visited.add(current.recid);
            parent = map.get(current.parentcategoryid);
        }

        results.push(current);
    }

    return results;
}


 export function storeAllCategoriesData(
                        node,
                        finalCategoryData,
                        parentChain = []
                    ) {
                        const currentChain = [...parentChain, node.name];
                        const fullParentPath = parentChain.join(" > ") || "";

                        finalCategoryData[node.recid] = `${node.name}$${node.color}$${fullParentPath}`;

                        if (node.children && node.children.length > 0) {
                            node.children.forEach((child) =>
                                storeAllCategoriesData(child, finalCategoryData, currentChain)
                            );
                        }
                    }